export const dining = [
  {
    id: 'the-godavari-room',
    name: 'The Godavari Dining Room',
    type: 'Fine Dining',
    image:
      'https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    images: [
      'https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
      'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    ],
    desc: 'Our signature restaurant offering contemporary European cuisine in an elegant setting. Perfect for formal dinners and special occasions.',
    longDesc:
      'The Godavari Dining Room is the pinnacle of culinary excellence at the Association. Under the direction of our Executive Chef, the kitchen presents a menu of authentic Andhra cuisine crafted from the finest seasonal ingredients. The elegant dining room, with its crystal chandeliers and attentive service, provides the perfect backdrop for celebratory dinners, romantic evenings, and important business entertaining.',
    timings: 'Dinner: Tue-Sun, 18:30 - 22:30',
    dressCode: 'Formal (Jacket required for gentlemen)',
    keyDetails: [
      { label: 'Cuisine', value: 'Contemporary European' },
      { label: 'Atmosphere', value: 'Elegant & Formal' },
      { label: 'Reservations', value: 'Required' },
    ],
  },
  {
    id: 'the-oak-lounge',
    name: 'The Oak Lounge',
    type: 'Casual Dining & Bar',
    image:
      'https://images.unsplash.com/photo-1572116469696-31de0f17ce34?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    images: [
      'https://images.unsplash.com/photo-1572116469696-31de0f17ce34?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
      'https://images.unsplash.com/photo-1514933651103-005eec06c04b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    ],
    desc: 'A relaxed atmosphere featuring classic club fare, an extensive selection of single malts, and a curated cigar menu.',
    longDesc:
      'The Oak Lounge is the social hub of the Club. With its comfortable leather seating, rich oak paneling, and relaxed atmosphere, it is the perfect place to meet friends or colleagues. The menu features classic club fare, from hearty sandwiches to comforting mains. The bar boasts an impressive collection of single malt whiskies, fine wines, and expertly crafted cocktails.',
    timings: 'Daily, 11:00 - 23:30',
    dressCode: 'Smart Casual',
    keyDetails: [
      { label: 'Cuisine', value: 'Classic Club Fare' },
      { label: 'Atmosphere', value: 'Relaxed & Convivial' },
      { label: 'Reservations', value: 'Walk-ins welcome' },
    ],
  },
  {
    id: 'the-terrace',
    name: 'The Garden Terrace',
    type: 'Al Fresco Dining',
    image:
      'https://images.unsplash.com/photo-1533777857889-4be7c70b33f7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    images: [
      'https://images.unsplash.com/photo-1533777857889-4be7c70b33f7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
      'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    ],
    desc: 'Enjoy light lunches, afternoon tea, and evening cocktails overlooking the manicured club gardens.',
    longDesc:
      'Open during the warmer months, The Garden Terrace offers a delightful al fresco dining experience. Overlooking the beautifully manicured club gardens, it is an idyllic spot for a light summer lunch, traditional afternoon tea, or evening cocktails as the sun sets. The menu focuses on fresh, seasonal salads, grilled seafood, and refreshing beverages.',
    timings: 'Daily, 08:00 - 20:00 (Seasonal)',
    dressCode: 'Casual',
    keyDetails: [
      { label: 'Cuisine', value: 'Light Bites & Afternoon Tea' },
      { label: 'Atmosphere', value: 'Breezy & Scenic' },
      { label: 'Season', value: 'May to September' },
    ],
  },
]

export const getDiningBySlug = (slug: string) =>
  dining.find((d) => d.id === slug)
